<div #container class="outline-tree-view" [class.has-error]="!!error()" (keydown)="onContainerKeydown($event)" tabindex="0">
  <div class="tree-container">
    <div class="tree-content">
      @for (item of flatTree(); track item.node.id) {
        <div
          class="tree-node"
          [style.padding-left.px]="item.depth * 20"
          [class.is-selected]="selectedNodeId() === item.node.id"
          [class.is-root]="item.depth === 0"
          [class.is-main-branch]="item.depth === 1"
        >
        <div class="node-content">
          @if (item.node.children.length > 0) {
            <button
              type="button"
              class="expand-btn"
              [attr.aria-label]="isExpanded(item.node.id) ? translations().collapse : translations().expand"
              [attr.aria-expanded]="isExpanded(item.node.id)"
              (click)="toggleExpand(item.node.id, true)"
            >
              <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
                @if (isExpanded(item.node.id)) {
                  <use href="/assets/icons/sprite.svg#icon-chevron-down"></use>
                } @else {
                  <use href="/assets/icons/sprite.svg#icon-chevron-right"></use>
                }
              </svg>
            </button>
          } @else {
            <div class="expand-placeholder"></div>
          }

          @if (isEditing(item.node.id)) {
            <input
              #editInput
              type="text"
              class="node-edit"
              [value]="item.node.topic"
              (blur)="finishEdit(item.node.id, $event.target.value)"
              (keydown)="onNodeKeydown($event, item.node.id, $event.target.value)"
              autofocus
            />
          } @else {
            <div class="node-label" (dblclick)="startEdit(item.node.id)" (click)="selectNode(item.node.id)">
              <span class="node-bullet">•</span>
              <span class="node-text" [innerHTML]="getNodeHtml(item.node)"></span>
            </div>
            @if (!disabled()) {
              <button
                type="button"
                class="add-btn"
                [attr.aria-label]="translations().addItem"
                (click)="createNode(item.node.id)"
                [title]="translations().addItemTitle"
              >
                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                  <use href="/assets/icons/sprite.svg#icon-plus"></use>
                </svg>
              </button>
              <button
                type="button"
                class="delete-btn"
                [attr.aria-label]="translations().deleteItem"
                (click)="deleteNode(item.node.id)"
                [title]="translations().deleteItemTitle"
              >
                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                  <use href="/assets/icons/sprite.svg#icon-trash"></use>
                </svg>
              </button>
            }
          }
        </div>
      </div>
    }
    </div>
  </div>

  @if (error()) {
    <div class="outline-error" role="status">
      {{ getErrorMessage(error()) }} ({{ translations().lineLabel }} {{ error()?.line }})
    </div>
  }
</div>
